import React from 'react';
import { format, isToday, isYesterday } from 'date-fns';
import { CheckIcon } from '@radix-ui/react-icons';

import { FilePreview } from '../../../components/icons/FilePreview';
import { formatTimeOfDay } from '../../../core/services/date.service';

import styles from './version-list-item.module.scss';
type VersionListItemProps = {
  version: number;
  name: string;
  date: Date;
  uploader: string;
  onClick: () => void;
  thumbnail?: string;
  fileType?: string;
  extension?: string;
  isSelected?: boolean;
};

export const VersionListItem: React.FC<VersionListItemProps> = ({
  version,
  name,
  date,
  uploader,
  thumbnail,
  extension,
  isSelected = false,
  onClick,
}) => (
  <div className={styles['item']} onClick={onClick}>
    <div className={styles['version']} data-selected={isSelected}>
      <CheckIcon color="var(--color-primary-crayola)" />

      <div>
        <span>v</span>
        {version}
      </div>
    </div>

    {thumbnail ? (
      <img className={styles['thumbnail']} src={thumbnail} />
    ) : (
      <div className={styles['file-preview-wrapper']}>
        <FilePreview text={extension} />
      </div>
    )}

    <div className={styles['detail']} data-selected={isSelected}>
      <h3>{name}</h3>
      <span>
        {uploader && `${uploader} - `}
        {date && isToday(new Date(date))
          ? 'Today'
          : isYesterday(new Date(date))
          ? 'Yesterday'
          : format(new Date(date), 'MMM dd, yyyy')}
        , {date && formatTimeOfDay(new Date(date))}
      </span>
    </div>
  </div>
);
